import { render, staticRenderFns } from "./merge-clients.vue?vue&type=template&id=52923b44&scoped=true"
import script from "./merge-clients.vue?vue&type=script&lang=js"
export * from "./merge-clients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52923b44",
  null
  
)

export default component.exports